import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Home from '../Pages/Home'
import About from '../Pages/About'
import Contact from '../Pages/Contact'
import ProductDetail from '../Pages/ProductDetails'
import Products from '../Pages/Products'
import OurTeam from '../Pages/OurTeam'
import Mission from '../Pages/Mission'

const Router = () => {
  return (
    <Routes>
      <Route path='/' element={<Home />}/>
      <Route path='/company/about' element={<About />}/>
      <Route path='/Company/team' element={<OurTeam />}/>
      <Route path='/Company/vision-mission' element={<Mission />}/>
      <Route path='/contact-us' element={<Contact />}/>
      <Route path='/products' element={<Products />}/>
      <Route path='/product/:id' element={<ProductDetail />}/>
      
      
    </Routes>
  )
}

export default Router
